import { ReactElement, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import BannerWrapper from '@Hotels-at-Home/hah-fe-core/dist/components/BannerWrapper';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
// import BmsmChart from '~/ui/components/common/Banner/BmsmChart';
import Modal from '@Hotels-at-Home/hah-fe-core/dist/components/Modal';

interface IProps {
  promotion: IGetPromotionResponse;
}

const HeroSection = ({ promotion }: IProps): ReactElement => {
  const { route } = useRouter();
  const { t } = useTranslation('', { keyPrefix: '' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tHero } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });

  const [showBMSMModal, setShowBMSMModal] = useState(false);

  const openPopup = () => {
    setShowBMSMModal(true);
  };

  const closePopup = () => {
    setShowBMSMModal(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      openPopup();
    }
  };

  let RenderBanners;

  if (promotion?.promo_is_active && promotion?.promo_type !== 'bmsm') {
    RenderBanners = <BannerWrapper promotion={promotion} />;
  } else if (promotion?.promo_is_active && promotion?.promo_type === 'bmsm') {
    RenderBanners = (
      <>
        <div
          role="button"
          tabIndex={0}
          aria-pressed="false"
          className="bmsm-banner-wrapper"
          onClick={openPopup}
          onKeyDown={handleKeyDown}
        >
          <BannerWrapper promotion={promotion} />
        </div>
        <Modal
          open={showBMSMModal}
          maxWidth="sm"
          className="base-banner-lightbox bmsm-lightbox"
          onClose={closePopup}
        >
          {/* <div className="content">
            <BmsmChart />
          </div> */}
        </Modal>
      </>
    );
  } else {
    RenderBanners = null;
  }

  return (
    <section className="base-section hero-section main-hp hp-section">
      {/* Main Hero Banner */}
      <Link href={`${t('$local.$homePageLinks.$heroSection.mainHero')}`} id="HP_hero">
        <picture>
          <source srcSet="/images/misc/fill.gif" media="(max-width: 768px)" />
          <img
            src="/images/homepage/renaissance-hotels-bed.webp"
            alt={tHero('alt')}
            className="hero-image"
            width={1440}
            height={804}
            loading="eager"
            fetchPriority="high"
          />
        </picture>
        <div className="stack">
          {/* Visual copy of the sr-only h1 in Home.tsx, hidden from AT to avoid a duplicate */}
          <div className="hero-title font-main-heading-big" aria-hidden="true">
            {tHero('title')}
          </div>
          <Button>{tHero('shopBed')}</Button>
        </div>
      </Link>
    </section>
  );
};

export default HeroSection;
